export default __webpack_public_path__ + "static/media/pressure.af2bf01b.png";